import {
  Directive,
  forwardRef,
  HostBinding,
  HostListener,
  OnChanges,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { INITIAL_CONFIG, NgxMaskDirective, NgxMaskService } from 'ngx-mask';

const DEFAULT_PARAMS = {
  maskExpression: '(000) 000-00-00',
  prefix: '+7',
  validation: true,
  showMaskTyped: false,
};

/**
 * Исправляет ошибки в библиотеке ngx-mask для
 * корректной работы маски телефонного номера.
 */
@Directive({
  selector: '[sdPhoneMaskFix]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneMaskFixDirective),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhoneMaskFixDirective),
      multi: true,
    },
    {
      provide: INITIAL_CONFIG,
      useValue: DEFAULT_PARAMS,
    },
    NgxMaskService,
  ],
})
export class PhoneMaskFixDirective extends NgxMaskDirective implements OnChanges {
  @HostBinding('attr.inputmode') inputMode = 'numeric';
  @HostBinding('attr.placeholder') placeholder = '+7';

  constructor() {
    super();

    // Так как мы не используем @Input, то нужно вызвать ngOnChanges вручную
    const changes: SimpleChanges = {};
    Object.entries(DEFAULT_PARAMS).forEach(([key, value]) => {
      changes[key] = new SimpleChange(null, value, true);
    });
    super.ngOnChanges(changes);
  }

  // Создан отдельный метод, так как в классе родителе уже есть onPaste с HostListener без эвента
  // при вставке номера телефона с 8 или 7 вначале, лишние цифры в начале удаляются,
  // чтобы не получалось номера телефона вместо +7(923) 456-78-90 - +7(792) 345-67-89
  @HostListener('paste', ['$event'])
  customOnPaste(e: ClipboardEvent): void {
    e.preventDefault();
    e.stopPropagation();

    const clipboardData = e.clipboardData;
    const pastingData = clipboardData?.getData('Text') || '';
    const finalValue = this.onlyDigits(pastingData).slice(-10);
    this.writeValue(finalValue).then(() => {
      this.onChange(finalValue);
    });
  }

  private onlyDigits(value: string): string {
    return value.replace(/\D+/g, '');
  }
}
